import React, { useState, useEffect } from 'react';
import InspectorRoutes from './InspectorRoutes/InspectorRoutes';
import MapInterface from './MapInterface/MapInterface';
import FailedAssignmentsModal from './FailedAssignments/FailedAssignmentsModal';

function RoutesDashboard({ optimizedRoutes, failedAssignments, selectedDate, isRetrievingRoutes, setPage, currentUser }) {
    const [selectedInspector, setSelectedInspector] = useState(null);
    const [showFailedAssignmentsModal, setShowFailedAssignmentsModal] = useState(false);

    // Show failed assignments modal when component mounts if there are failed assignments
    useEffect(() => {
        if (failedAssignments && failedAssignments.length > 0) {
            setShowFailedAssignmentsModal(true);
        }
    }, [failedAssignments]);

    // Color palette from teams product
    const COLORS = [
        '#8377fd', '#55caf5', '#f55578', '#ffaf00', '#01a240', '#4426d9', '#d926d9', '#d92644', '#d99d26', '#80d926',
        '#996633', '#26bbd9', '#2626d9', '#bb26d9', '#d92662', '#d98026', '#9dd926', '#26d944', '#26d9d9', '#2644d9',
        '#808080', '#d92680', '#d96226', '#bbd926', '#26d926', '#26d9bb', '#2662d9', '#7f26d9', '#d9269d', '#d94426',
        '#664c33', '#44d926', '#26d99d', '#267fd9', '#6226d9', '#d926bb', '#d92626', '#d9bb26', '#62d926', '#26d980',
        '#269dd9', '#4426d9', '#d926d9', '#d92644', '#d99d26', '#80d926', '#26d962', '#26bbd9', '#2626d9', '#bb26d9',
        '#d92662', '#d98026', '#9dd926', '#26d944', '#26d9d9', '#2644d9', '#9d26d9', '#d92680', '#d96226', '#bbd926',
        '#26d926', '#26d9bb', '#2662d9', '#7f26d9', '#d9269d', '#d94426', '#d9d926', '#44d926', '#26d99d', '#267fd9',
        '#6226d9', '#d926bb', '#d92626', '#d9bb26', '#62d926', '#26d980', '#269dd9', '#4426d9', '#d926d9', '#d92644',
        '#d99d26', '#80d926', '#26d962', '#26bbd9', '#2626d9', '#bb26d9', '#d92662', '#d98026', '#9dd926', '#26d944',
        '#26d9d9', '#2644d9', '#9d26d9', '#d92680', '#d96226', '#bbd926', '#26d926', '#26d9bb', '#2662d9', '#7f26d9'
    ];

    // Add colors to each inspector object
    optimizedRoutes.forEach((route, index) => {
        route.assignedInspector.assignedColor = COLORS[index % COLORS.length];
    });

    // Generate colors for inspectors - now uses the assigned color
    const generateInspectorColor = (inspectorId, inspectorIndex) => {
        const route = optimizedRoutes.find(r => r.assignedInspector.INSPECTOR_ID === inspectorId);
        return route ? route.assignedInspector.assignedColor : COLORS[0];
    };

    // Show loading screen while retrieving routes
    if (isRetrievingRoutes) {
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-white">
                <div className="text-center max-w-md mx-auto px-6">
                    <div className="spinner-inspections mb-8">
                        <div className="spinner-outer-circle"></div>
                        <div className="spinner-inner-circle"></div>
                    </div>
                    
                    <h3 className="text-xl font-medium text-gray-900 mb-4">
                        Loading Routes
                    </h3>
                    
                    <p className="text-sm text-gray-500 mb-4">
                        Retrieving optimized routes for {selectedDate.toLocaleDateString('en-US', { 
                            weekday: 'long', 
                            year: 'numeric', 
                            month: 'long', 
                            day: 'numeric' 
                        })}
                    </p>
                    
                    <div className="text-xs text-gray-400">
                        This may take a few moments depending on the number of routes
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="flex h-full">
            {/* Inspector Routes Sidebar */}
            <InspectorRoutes 
                optimizedRoutes={optimizedRoutes}
                selectedInspector={selectedInspector}
                setSelectedInspector={setSelectedInspector}
                generateInspectorColor={generateInspectorColor}
                selectedDate={selectedDate}
                setPage={setPage}
                currentUser={currentUser}
            />

            {/* Map Interface */}
            <div className="flex-1 relative">
                <MapInterface 
                    optimizedRoutes={optimizedRoutes}
                    selectedInspector={selectedInspector}
                    generateInspectorColor={generateInspectorColor}
                />
            </div>

            {/* Failed Assignments Modal */}
            <FailedAssignmentsModal 
                failedAssignments={failedAssignments}
                isOpen={showFailedAssignmentsModal}
                onClose={() => setShowFailedAssignmentsModal(false)}
            />
        </div>
    );
}

export default RoutesDashboard;
